(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
"use strict";

require("../../../public/partials/contact-us/contact-us");

},{"../../../public/partials/contact-us/contact-us":2}],2:[function(require,module,exports){
"use strict";

(function ($) {
  $(document).ready(function () {
    initSelects();
  });

  // Simpler select elements, as requested for the Contact Us page.
  function initSelects() {
    loadYearSelect();
    getSelect(".dpfSetYear", true).change(function () {
      getSelect(".dpfSetMake").val("");
      getSelect(".dpfSetMake").html("");
      getSelect(".dpfSetModel").val("");
      getSelect(".dpfSetModel").html("");
      getSelect(".dpfSetEngine").val("");
      getSelect(".dpfSetEngine").html("");
      if ($(this).val()) {
        $(this).data("id", $(this).children("option:contains('" + $(this).val() + "')").data("id"));
        loadMakeSelect($(this).data("id"));
      }
    });
    getSelect(".dpfSetMake", true).change(function () {
      getSelect(".dpfSetModel").val("");
      getSelect(".dpfSetModel").html("");
      getSelect(".dpfSetEngine").val("");
      getSelect(".dpfSetEngine").html("");
      if ($(this).val()) {
        $(this).data("id", $(this).children("option:contains('" + $(this).val() + "')").data("id"));
        loadModelSelect(getSelectVal(".dpfSetYear"), $(this).data("id"));
      }
    });
    getSelect(".dpfSetModel", true).change(function () {
      getSelect(".dpfSetEngine").val("");
      getSelect(".dpfSetEngine").html("");
      if ($(this).val()) {
        $(this).data("id", $(this).children("option:contains('" + $(this).val() + "')").data("id"));
        loadEngineSelect($(this).data("id"));
      }
    });
  }
  function getSelect(className, all) {
    var selectFilter = ":not([disabled])";
    return $(className).children("div").children("select" + (all ? selectFilter : ""));
  }
  function getSelectVal(className) {
    return getSelect(className).data("id") || getSelect(className).val();
  }
  function loadYearSelect() {
    $.ajax({
      type: "POST",
      url: dpf.ajax_url,
      data: {
        action: "dpf_opticat_year_options"
      },
      success: function success(res) {
        getSelect(".dpfSetYear").html(res);
      },
      error: function error(err) {
        console.error(err);
      }
    });
  }
  function loadMakeSelect(year) {
    if (!year) {
      return;
    }
    $.ajax({
      type: "POST",
      url: dpf.ajax_url,
      data: {
        action: "dpf_opticat_make_options",
        year: year
      },
      success: function success(res) {
        getSelect(".dpfSetMake").html(res);
      },
      error: function error(err) {
        console.error(err);
      }
    });
  }
  function loadModelSelect(year, makeId) {
    if (!year || !makeId) return;
    $.ajax({
      type: "POST",
      url: dpf.ajax_url,
      data: {
        action: "dpf_opticat_model_options",
        year: year,
        makeId: makeId
      },
      success: function success(res) {
        getSelect(".dpfSetModel").html(res);
      },
      error: function error(err) {
        console.error(err);
      }
    });
  }
  function loadEngineSelect(baseVehicleId) {
    if (!baseVehicleId) return;
    $.ajax({
      type: "POST",
      url: dpf.ajax_url,
      data: {
        action: "dpf_opticat_engine_options",
        baseVehicleId: baseVehicleId
      },
      success: function success(res) {
        getSelect(".dpfSetEngine").html(res);
      },
      error: function error(err) {
        console.error(err);
      }
    });
  }
})(jQuery);

},{}]},{},[1]);
